import { Resume } from '@sr/types';
import Sections from '../common/Sections';
import { Box } from '../common/ui';
import BlockListSection from './BlockListSection';
import ContactInfo from './ContactInfo';
import DetailSection from './DetailSection';
import theme from './georgia-theme';
import Header from './Header';
import InlineListSection from './InlineListSection';

const Georgia = ({ resume }: { resume: Resume }) => {
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap"
        rel="stylesheet"
      />
      <Header resume={resume} />
      <Box
        className="pdf-page-container"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
        }}
      >
        <Box
          className="pdf-page-column"
          sx={{
            width: ['100%', '25%'],
            zIndex: 2,
            order: [2, 1],
            pr: 16,
          }}
        >
          <ContactInfo resume={resume} />
          <Sections
            resume={resume}
            filter="list"
            DetailSection={DetailSection}
            BlockListSection={BlockListSection}
            InlineListSection={InlineListSection}
          />
        </Box>
        <Box
          className="pdf-page-column"
          sx={{
            width: ['100%', '75%'],
            order: [1, 2],
          }}
        >
          <Sections
            resume={resume}
            filter="detail"
            DetailSection={DetailSection}
            BlockListSection={BlockListSection}
            InlineListSection={InlineListSection}
          />
        </Box>
      </Box>
    </>
  );
};

Georgia.theme = theme;
export default Georgia;
